import { useQuery, gql } from "@apollo/client";

const StoreAvataxCertificatesInfo_ClinicShared_Query = gql`
  query StoreAvataxCertificatesInfo_ClinicShared_Query {
    currentStore {
      id
      hasUnexpiredWholesaleTaxCertificate
      numberOfExpiringAvataxCertificates
    }
  }
`;

interface StoreAvataxCertificatesInfoData {
  currentStore: {
    id: string;
    hasUnexpiredWholesaleTaxCertificate: boolean;
    numberOfExpiringAvataxCertificates: number;
  };
}

const useStoreAvataxCertificatesInfoQuery = () =>
  useQuery<StoreAvataxCertificatesInfoData>(StoreAvataxCertificatesInfo_ClinicShared_Query);

export type { StoreAvataxCertificatesInfoData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useStoreAvataxCertificatesInfoQuery, StoreAvataxCertificatesInfo_ClinicShared_Query };
